module.exports = __webpack_public_path__ + "img/62.15893f03.jpg";